import React from "react";
import ReactDOM from "react-dom/client";
import App from "app/App";
import { AppProviders } from "app/providers/AppProviders";
import "./styles/index.css";

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
